import React from "react";
import { useTheme } from "@emotion/react";
import { 
    ContainerPrimary, 
    TextPrimary,
    LinkPrimary 
} from "../styles/styledComponents";
import { AppBar } from "@mui/material";
import { Container } from "@mui/system";

const headerHeight = 100;
interface NavOption {
    name: string;
    value: string
};

interface HeaderProps {
    navOptions: NavOption[];
    setNavigationValue: (name: string) => void
};
export default function Header({navOptions,setNavigationValue}: HeaderProps) {
    const theme = useTheme();
    const navSection = navOptions.map((opt:NavOption) => <LinkPrimary onClick={()=>setNavigationValue(opt.value)}>
        {opt.name}
    </LinkPrimary>);
    return (<>
        <AppBar>
            <ContainerPrimary
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: headerHeight,
                    width: "100%",
                }}
            >
            <span style={{display:"flex", flexDirection:"row"}}>
                <img src="https://www.gritiam.com/images/icons/Gritlogo-greenBase-tiny.png" style={{paddingRight:"10px"}}/>
                <TextPrimary variant="h4">Grit Proxy Configuration</TextPrimary>
            </span>
            {navSection}
            <LinkPrimary>
                Demo Account
            </LinkPrimary>
        </ContainerPrimary>
        </AppBar>
        <Container sx={{height: headerHeight}}></Container>
    </>)
}
